<template>
  <label class="cd-checkbox" :class="{ 'cd-checkbox--field': field, disabled: disabled }">
    <input :id="cbId"
           type="checkbox"
           :value="value"
           :disabled="disabled"
           v-model="model" />
    <span class="cd-checkbox__mark"></span>
    <!-- Only when there is text: several call sites (FileExplorer) use the
         checkbox on its own, and an empty span would leave a trailing gap. -->
    <span v-if="$slots.default" class="cd-checkbox__text"><slot></slot></span>
  </label>
</template>
<script>
  export default {
    name: 'base-checkbox',
    model: {
      prop: 'checked'
    },
    props: {
      checked: [Array, Boolean],
      disabled: [Boolean, String],
      value : [String,Number],
      inline: {
        type : Boolean,
        default : false
      },
      // Placed on the real <input> so an external <label for="..."> resolves.
      // It has to be a declared prop: otherwise Vue drops it on the root
      // element and the "for" points at something that cannot be labelled.
      id : String,
      // Renders the text as a field title (small uppercase) instead of plain
      // running text. See .cd-checkbox--field in variations.scss.
      field: {
        type : Boolean,
        default : false
      }
    },
    data () {
      return {
        cbId: ''
      }
    },
    computed: {
      model: {
        get () {
          return this.checked
        },
        set (check) {
          this.$emit('input', check)
        }
      },
    },
    created () {
      // Random fallback so the input always has an id, even when the caller
      // does not pass one.
      this.cbId = this.id || Math.random().toString(16).slice(2)
    }
  }
</script>
